import { render, staticRenderFns } from "./ExcluirConta.vue?vue&type=template&id=6986c8cf&scoped=true"
import script from "./ExcluirConta.vue?vue&type=script&lang=js"
export * from "./ExcluirConta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6986c8cf",
  null
  
)

export default component.exports